enum ActionType {
  UPDATE_BASE_TREE = 'UPDATE_BASE_TREE',
  UPDATE_EXTEND_TREE = 'UPDATE_EXTEND_TREE',
  UPDATE_LBS_TREE = 'UPDATE_LBS_TREE',

  UPDATE_TREE_LABEL = 'UPDATE_TREE_LABEL',
  UPDATE_TREE_LBSLABEL = 'UPDATE_TREE_LBSLABEL',


  UPDATE_SEARCH_TAG = 'UPDATE_SEARCH_TAG',
  UPDATE_SEARCH_TREND = 'UPDATE_TREND_SEARCH',
  UPDATE_SUM = 'UPDATE_SUM',

  SET_PEOPLE_TAGS = 'PUSH_PEOPLE_TAGS',
  SET_CREATE_PEOPLE_TAGS = 'SET_PEOPLE_CREATE_TAGS',
  
  UPDATE_STATE = 'UPDATE_STATE'
}


export const LIST_PAGINATION_GROUP_ID = -10


export default ActionType